import { crudActions } from "./CrudActions"

export default {
  ...crudActions("ambits-generals"),
}
